import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  BulkRemoveLikedGoodsParams,
  BulkRemoveLikedGoodsResponse,
} from './types';

export const bulkRemoveLikedGoods = ({
  like_snos,
  target_folder_sno,
}: BulkRemoveLikedGoodsParams) => {
  return defaultHttpClient
    .request<BulkRemoveLikedGoodsResponse>({
      method: 'DELETE',
      url: '/api/v2/members/me/liked_goods/',
      data: {
        like_snos,
        target_folder_sno,
      },
    })
    .then(result => result.data);
};
